import {usePath} from '@github-ui/code-view-shared/contexts/PathContext'
import {useCurrentRepository} from '@github-ui/current-repository'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {ReposFileTreePane, type ReposFileTreePaneProps} from '@github-ui/repos-file-tree-view'

import {useIsFilePage} from '../../hooks/use-is-file-page'
import {codeViewLayoutRoute} from '../../routes/code-view-layout-route'

type ReposFileTreePaneWrapperProps = Omit<
  ReposFileTreePaneProps,
  'path' | 'isFilePath' | 'repo' | 'refInfo' | 'incompleteFileTree'
>

export function ReposFileTreePaneWrapper({fileTree, ...props}: ReposFileTreePaneWrapperProps) {
  const {
    data: {refInfo},
  } = useRouteQuery(codeViewLayoutRoute, 'mainQuery')

  const repo = useCurrentRepository()

  const isFilePage = useIsFilePage()
  const path = usePath()

  if (!refInfo || !repo || !fileTree) return null

  return (
    <ReposFileTreePane
      {...props}
      fileTree={fileTree}
      repo={repo}
      refInfo={refInfo}
      path={path}
      isFilePath={isFilePage}
      incompleteFileTree={false}
    />
  )
}
